import IsuStrategisCard from "@/app/Components/IsuStrategisCard";
import React from "react";
import { motion } from "framer-motion";

const IsuStrategis = () => {
  const dataDummy = [
    {
      title: "Data UMKM yang Belum Terintegrasi",
      description:
        "Data UMKM masih tersebar di 27 K/L, sehingga perlu dilakukan Pemanfaatan dan Optimalisasi Data UMKM yang sudah ada dan menambah reliabilitas data UMKM yang bisa dibagi pakai, Selain itu, akan dilakukan integrasi data dan program pemberdayaan UMKM melalui SAPA UMKM",
    },
    {
      title:
        "UMKM Masih Didominasi Usaha Mikro & Terbatasnya Akses Pembiayaan Bagi UMKM",
      description:
        "Meningkatkan Formalisasi Usaha (NIB, Sertifikasi&Standardisasi) & Perluasan Akses Pembiayaan KUR dan Alternatif Pembiayaan lain.",
    },
    {
      title: "Rendahnya Partisipasi UMKM dalam Kemitraan",
      description:
        "Penguatan SDM UMKM yang berdaya saing, Penguatan Hilirisasi UMKM, Kemitraan antara UMKM dan Usaha Besar serta BUMN/BUMD",
    },
    {
      title: "Keterbatasan Pasar Domestik dan Global",
      description:
        "Fasilitasi Pemenuhan Sertifikasi Berstandar Internasional & Fasilitasi business matching untuk mendorong keterlibatan UMKM dalam rantai pasok dan kontribusi terhadap aktivitas ekspor",
    },
    {
      title: "Tingkat Rasio Kewirausahaan Masih Rendah",
      description:
        "Penciptaan dan Penguatan Ekosistem Kewirausahaan melalui Entrepreneur Hub & Peningkatan Kapasitas Wirausaha/Start-Up melalui Inkubasi Usaha",
    },
    {
      title: "Peningkatan Kapasitas Usaha UMKM melalui Pelaksaan Kartu Usaha",
      description: `
      Kartu Usaha merupakan program pemberdayaan ekonomi bagi UMKM dan tenaga kerja yang berfokus pada peningkatan kapasitas UMKM dan wirausaha yang mandiri dan berdaya saing, yang terdiri dari:
      <ol class='list-decimal pl-5 mt-2'>
        <li>
          <span class='font-medium'>Kartu Usaha Produktif</span> (penguatan ekonomi kelas menengah,
          <span class='font-medium'> Kementerian UMKM sebagai Penanggung Jawab Program</span>)
        </li>
        <li>
          <span class='font-medium'>Kartu Usaha Afirmatif</span> (penguatan ekonomi bagi kelompok masyarakat miskin dan rentan,
          <span class='font-medium'> Kementerian UMKM sebagai K/L Pendukung</span>)
        </li>
      </ol>
    `,
    },
    {
      title: "Holding UMKM",
      description:
        "Memudahkan intervensi program pemerintah kepada UMKM binaan serta meningkatkan kapasitas UMKM untuk mencapai skala ekonomi, konektivitas dengan sumberdaya produktif.",
    },
    {
      title: "Penghapusan Piutang UMKM",
      description:
        "Sebagaimana Peraturan Pemerintah No.47/2024 Tentang Penghapusan Piutang Macet kepada UMKM pada bidang pertanian, perkebunan, peternakan, dan kelautan serta UMKM lainnya",
    },
    {
      title:
        "Keterlibatan UMKM dalam Program MBG dan Penyediaan 3 Juta Perumahan Rakyat",
      description: `
        <ol class='list-decimal pl-5 mt-2'>
          <li>Penyediaan akses bahan baku melalui koordinasi lintas stakeholder;</li>
          <li>Fasilitas pelatihan dan Pendampingan SDM UMKM; dan</li>
          <li>Perluasan dan kemudahan akses pembiayaan bagi UMKM yang terlibat.</li>
        </ol>
      `,
    },
  ];

  return (
    <div className="flex flex-col justify-center items-center gap-5 md:gap-10 px-5 sm:px-10 md:px-16 pb-10 md:pb-20 bg-gradient-to-t from-cust-orange to-white to-70% overflow-hidden">
      <motion.div
        className="w-full font-bold text-2xl sm:text-4xl lg:text-5xl text-cust-blue text-center md:text-left"
        initial={{ x: 50, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
          ease: "easeInOut",
        }}
        viewport={{ once: true }}
      >
        Isu Strategis dalam Pengembangan UMKM
      </motion.div>
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
        {dataDummy.map((data, index) => (
          <IsuStrategisCard key={index} data={data} index={index} />
        ))}
      </div>
    </div>
  );
};

export default IsuStrategis;
